import React from "react";
import DefaultCommunity from "../defaultCommunity";
import { useSelector } from "react-redux";

const FollowCommunities = () => {
  const userDetails = useSelector((state) => state?.SignInReducer?.userDetails);
  const { countryId, defaultTenantCountry } = userDetails?.userData || {};

  return (
    <>
      <DefaultCommunity
        signIn={true}
        hideSearch={true}
        countryId={countryId}
        defaultTenantCountry={defaultTenantCountry}
      />
    </>
  );
};

export default FollowCommunities;
